var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-user-create"},[_c('AHeading',{staticClass:"admin-user-create__heading",attrs:{"level":1}},[_vm._v("従業員一括登録")]),_c('ALink',{attrs:{"back":""}},[_vm._v("< 戻る")]),_c('OUserCrateCsv')],1)}
var staticRenderFns = []

export { render, staticRenderFns }